/**
 * @fileoverview Provide shared semantic text labels for workspace state. Callers supply the business meaning and severity; the tag owns presentation only. `AppBadge.js` provides the compact value-oriented counterpart.
 */

import React from 'react'

const severityColors = {
    success: { bg: '#dcfce7', color: '#15803d', border: '#bbf7d0' },
    danger: { bg: '#fee2e2', color: '#b91c1c', border: '#fecaca' },
    warning: { bg: '#fef9c3', color: '#a16207', border: '#fde68a' },
    info: { bg: '#dbeafe', color: '#1d4ed8', border: '#bfdbfe' },
    secondary: { bg: 'var(--surface-200, #e2e8f0)', color: 'var(--text-color-secondary, #64748b)', border: 'var(--surface-border)' }
}



function AppTag({ value, severity = 'info', rounded, className, style: extraStyle }) {
    const colors = severityColors[severity] || severityColors.info
    const style = {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.2rem 0.65rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        borderRadius: rounded ? '999px' : '6px',
        backgroundColor: colors.bg,
        color: colors.color,
        border: `1px solid ${colors.border}`,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        ...extraStyle
    }

    return (
        <span className={className || ''} style={style}>
            {value}
        </span>
    )
}

export default AppTag
